import {Button, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import MantineDropdownMenu from 'ui-library/menus/MantineDropdownMenu';

export interface FileVersionOption {
  id: string;
  versionNumber: number;
}

interface FileVersionDropdownProps {
  currentVersionId: string | null;
  onSelectVersion: (versionId: string) => void;
  selectedVersion: FileVersionOption;
  /** Versions to offer, newest first. */
  versions: Array<FileVersionOption>;
}

const useStyles = createStyles((theme) => ({
  trigger: {
    borderRadius: theme.radius.xl,
  },
}));

export function formatVersionLabel(version: FileVersionOption, currentVersionId: string | null): string {
  return version.id === currentVersionId
    ? `Current version (v${version.versionNumber})`
    : `Version ${version.versionNumber}`;
}

export default function FileVersionDropdown({
  currentVersionId,
  onSelectVersion,
  selectedVersion,
  versions,
}: FileVersionDropdownProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <MantineDropdownMenu
      position="bottom-start"
      sections={[
        {
          items: versions.map((version) => ({
            name: formatVersionLabel(version, currentVersionId),
            onSelect: () => {
              onSelectVersion(version.id);
            },
          })),
        },
      ]}
      trigger={
        <Button
          aria-label="Select file version"
          className={classes.trigger}
          rightIcon={<BenchlingIcon icon="chevron-down" />}
          size="xs"
          variant="secondary"
        >
          {formatVersionLabel(selectedVersion, currentVersionId)}
        </Button>
      }
    />
  );
}
